import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.conversation.WmConversationEntry.';
  public static readonly attention = `${Id.prefix}attention`;
  public static readonly cancel = `${Id.prefix}cancel`;
  public static readonly saveDraftComment = `${Id.prefix}saveDraftComment`;
  public static readonly postComment = `${Id.prefix}postComment`;
  public static readonly posted = `${Id.prefix}posted`;
  public static readonly noContentInEntry = `${Id.prefix}noContentInEntry`;
  public static readonly attachments = `${Id.prefix}attachments`;
  public static readonly pleaseAddContentToComment = `${Id.prefix}pleaseAddContentToComment`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangDealerFranchiseeConversationWmConversationEntry {
  private constructor() {}
  public static attention(): string {
    return interpolate(Id.attention);
  }
  public static cancel(): string {
    return interpolate(Id.cancel);
  }
  public static saveDraftComment(): string {
    return interpolate(Id.saveDraftComment);
  }
  public static postComment(): string {
    return interpolate(Id.postComment);
  }
  public static posted(): string {
    return interpolate(Id.posted);
  }
  public static noContentInEntry(): string {
    return interpolate(Id.noContentInEntry);
  }
  public static attachments(): string {
    return interpolate(Id.attachments);
  }
  public static pleaseAddContentToComment(): string {
    return interpolate(Id.pleaseAddContentToComment);
  }
}

export class DealerFranchiseeConversationWmConversationEntryModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.attention, 'Attention:', 'Label for attention user list');
    register.add(Id.cancel, 'Cancel', 'Cancel button');
    register.add(Id.saveDraftComment, 'Save Draft Comment', 'Button to save draft comment');
    register.add(Id.postComment, 'Post Comment', 'Button to post comment');
    register.add(Id.posted, 'posted', 'Label for posted time');
    register.add(Id.noContentInEntry, 'There is no content in this entry', 'Message for empty entry');
    register.add(Id.attachments, 'Attachments', 'Label for attachments section');
    register.add(
      Id.pleaseAddContentToComment,
      'Please add content to the comment before posting',
      'Validation message for empty comment'
    );
  }
}
